module.exports = __webpack_public_path__ + "static/gippsland-social-4568519074d8665b21c8c07001e85081.png";